import { useState, useEffect } from "react";
import { getLeaveTypeFullAPI } from "../services/welfare-leave";
import { useSelector } from "react-redux";

function UseLeaveTypeFull() {
  const roleId = useSelector((state) => state.roleReducer.role);
  const [data, setData] = useState([]);

  useEffect(() => {
    const getData = async () => {
      const resp = await getLeaveTypeFullAPI({ orgId: roleId });
      if (!resp) return;
      if (resp.status) {
        const newData = resp.result.map((d, i) => {
          return {
            value: d.leaveTypeId,
            label: `${d.leaveTypeTh} `,
          };
        });
        setData(newData);
      } else {
        setData([]);
      }
    };
    getData();
  }, [roleId]);
  return data;
}

export default UseLeaveTypeFull;
